// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_wrapper__QGqoV {
  overflow-y: auto;
  max-height: 410px;
  padding-right: 16px;
}
.style_wrapper__QGqoV::-webkit-scrollbar {
  width: 4px;
  background-color: #fff;
}
.style_wrapper__QGqoV::-webkit-scrollbar-thumb {
  background-color: #a4a8b3;
  border-radius: 25px;
}
.style_wrapper__QGqoV::-webkit-scrollbar-thumb:hover {
  background-color: #a4a8b3;
}

.style_createLead__5qQJd {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.style_title__4tjWi {
  margin: 20px auto;
}

.style_files__dfq\\+S {
  display: flex;
  flex-direction: column;
  justify-items: center;
  color: "#434243";
}
.style_files__dfq\\+S h3 {
  font-size: 16px;
}
.style_files__dfq\\+S h2,
.style_files__dfq\\+S h3,
.style_files__dfq\\+S h4,
.style_files__dfq\\+S h5,
.style_files__dfq\\+S p {
  margin: 0;
}
.style_files__dfq\\+S h4 {
  color: #434243;
  font-size: 12px;
  font-weight: 500;
}
.style_files__dfq\\+S h5 {
  color: #434243;
  font-size: 10px;
}
.style_files__dfq\\+S .style_uploadField__zup85 {
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  border: 2px dashed #220d77;
  stroke-dasharray: 5;
  width: 100%;
  margin: 12px 0;
}
.style_files__dfq\\+S .style_file__J8fqh {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;
}

.style_fileIconType__6Nwde {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_fileIconType__6Nwde svg {
  z-index: 1;
  height: 28px;
  width: 28px;
  color: #434243;
}
.style_fileIconType__6Nwde p {
  margin: 0;
  position: absolute;
  color: #fff;
  font-size: 7px;
  z-index: 2;
  margin-top: 6px;
}
.style_fileIconType__6Nwde svg {
  cursor: pointer;
}

.style_fileName__OUV4C {
  display: flex;
  align-items: center;
  width: 75%;
  font-size: 12px;
  font-weight: 500;
  color: #434243;
}

.style_fileActions__HhjJH {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.style_fileActions__HhjJH svg {
  color: #434243;
}

.style_fileType__qQrLK {
  margin-right: 16px;
}

.style_notes__kDTmW {
  margin: 16px 0;
  margin-top: 10%;
}
.style_notes__kDTmW h2,
.style_notes__kDTmW h3,
.style_notes__kDTmW h4,
.style_notes__kDTmW h5,
.style_notes__kDTmW p {
  margin: 0;
}
.style_notes__kDTmW h3 {
  font-size: 16px;
  margin-bottom: 12px;
}

.style_textArea__IWFDi {
  width: 100%;
  border: unset;
  padding: 19px;
  border-radius: 8px;
  border-bottom-right-radius: 0px;
  border: 1px solid #a4a8b3;
  background: #f8f8f8;
}

.style_timeline__S-NjL {
  margin: 16px 0;
  display: flex;
}
.style_timeline__S-NjL h2,
.style_timeline__S-NjL h3,
.style_timeline__S-NjL h4,
.style_timeline__S-NjL h5,
.style_timeline__S-NjL p {
  margin: 0;
}
.style_timeline__S-NjL h3 {
  font-size: 16px;
  margin-bottom: 12px;
}

.style_current__E8wSR {
  border: 2px solid #220d77;
  padding: 8px;
  box-sizing: content-box;
}

.style_dot__NjP0p {
  height: 10px;
  width: 10px;
  border-radius: 100px;
  color: #220d77;
}

.style_line__07eGm {
  border-left: 2px solid #220d77;
  height: 100px;
  width: fit-content;
  display: block;
  position: relative;
  left: 14px;
  top: -5px;
}

.style_activity__cVI0D {
  margin-left: 12px;
}`, "",{"version":3,"sources":["webpack://./src/views/Leads/LeadsList/components/style.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;AACF;AACE;EACE,UAAA;EACA,sBAAA;AACJ;AAEE;EACE,yBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AAFF;AAGE;EACE,eAAA;AADJ;AAGE;;;;;EAKE,SAAA;AADJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGE;EACE,cAAA;EACA,eAAA;AADJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AADJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AADJ;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAGE;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AADJ;AAGE;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AADJ;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EAEA,eAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAFF;AAGE;EACE,cAAA;AADJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;AADF;AAEE;;;;;EAKE,SAAA;AAAJ;AAEE;EACE,eAAA;EACA,mBAAA;AAAJ;;AAGA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;AAAF;AAEE;;;;;EAKE,SAAA;AAAJ;AAEE;EACE,eAAA;EACA,mBAAA;AAAJ;;AAGA;EACE,yBAAA;EACA,YAAA;EACA,uBAAA;AAAF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;AACF;;AACA;EACE,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAEF;;AAAA;EACE,iBAAA;AAGF","sourcesContent":[".wrapper {\n  overflow-y: auto;\n  max-height: 410px;\n  padding-right: 16px;\n\n  &::-webkit-scrollbar {\n    width: 4px;\n    background-color: #fff;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #a4a8b3;\n    border-radius: 25px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #a4a8b3;\n  }\n}\n\n.createLead {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  margin: 20px auto;\n}\n\n.files {\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  color: '#434243';\n  h3 {\n    font-size: 16px;\n  }\n  h2,\n  h3,\n  h4,\n  h5,\n  p {\n    margin: 0;\n  }\n  h4 {\n    color: #434243;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  h5 {\n    color: #434243;\n    font-size: 10px;\n  }\n  .uploadField {\n    display: flex;\n    flex-direction: column;\n    padding: 24px 16px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    align-self: stretch;\n    border-radius: 8px;\n    border: 2px dashed #220d77;\n    stroke-dasharray: 5;\n    width: 100%;\n    margin: 12px 0;\n  }\n  .file {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 8px;\n  }\n}\n.fileIconType {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    z-index: 1;\n    height: 28px;\n    width: 28px;\n    color: #434243;\n  }\n  p {\n    margin: 0;\n    position: absolute;\n    color: #fff;\n    font-size: 7px;\n    z-index: 2;\n    margin-top: 6px;\n  }\n  svg {\n    cursor: pointer;\n  }\n}\n\n.fileName {\n  display: flex;\n  align-items: center;\n  width: 75%;\n\n  font-size: 12px;\n  font-weight: 500;\n  color: #434243;\n}\n.fileActions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  svg {\n    color: #434243;\n  }\n}\n.fileType {\n  margin-right: 16px;\n}\n\n.notes {\n  margin: 16px 0;\n  margin-top: 10%;\n  h2,\n  h3,\n  h4,\n  h5,\n  p {\n    margin: 0;\n  }\n  h3 {\n    font-size: 16px;\n    margin-bottom: 12px;\n  }\n}\n.textArea {\n  width: 100%;\n  border: unset;\n  padding: 19px;\n  border-radius: 8px;\n  border-bottom-right-radius: 0px;\n  border: 1px solid #a4a8b3;\n  background: #f8f8f8;\n}\n\n.timeline {\n  margin: 16px 0;\n  display: flex;\n\n  h2,\n  h3,\n  h4,\n  h5,\n  p {\n    margin: 0;\n  }\n  h3 {\n    font-size: 16px;\n    margin-bottom: 12px;\n  }\n}\n.current {\n  border: 2px solid #220d77;\n  padding: 8px;\n  box-sizing: content-box;\n}\n.dot {\n  height: 10px;\n  width: 10px;\n  border-radius: 100px;\n  color: #220d77;\n}\n.line {\n  border-left: 2px solid #220d77;\n  height: 100px;\n  width: fit-content;\n  display: block;\n  position: relative;\n  left: 14px;\n  top: -5px;\n}\n.activity {\n  margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style_wrapper__QGqoV`,
	"createLead": `style_createLead__5qQJd`,
	"title": `style_title__4tjWi`,
	"files": `style_files__dfq+S`,
	"uploadField": `style_uploadField__zup85`,
	"file": `style_file__J8fqh`,
	"fileIconType": `style_fileIconType__6Nwde`,
	"fileName": `style_fileName__OUV4C`,
	"fileActions": `style_fileActions__HhjJH`,
	"fileType": `style_fileType__qQrLK`,
	"notes": `style_notes__kDTmW`,
	"textArea": `style_textArea__IWFDi`,
	"timeline": `style_timeline__S-NjL`,
	"current": `style_current__E8wSR`,
	"dot": `style_dot__NjP0p`,
	"line": `style_line__07eGm`,
	"activity": `style_activity__cVI0D`
};
export default ___CSS_LOADER_EXPORT___;
